import React, { Component } from 'react';
import InputFileIcon from '../../gb-components/InputFileIcon';
import IconFile from '../../assets/svg/ic-actions-add-file.svg';
import { getUltimaImportacao, postFormaOrg, postGrupo, postProcedimento, postSubGrupo } from '../../Libs/filaProcedimentos';
import PreLoaderWidget from '../../components/Loader';
import { Col, Row } from 'reactstrap';
import LoadingFullScreen from '../../components/LoadingFullScreen';
import moment from 'moment';
import Notificacao from '../../components/Notificacao';

export default class ImportacaoTabelas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            loading2: false,
            ultimaImport: {},
            error: "",
            nameclass: "alert-danger"
        }

        this.onChangeGrupo = this.onChangeGrupo.bind(this);
        this.onChangeSubGrupo = this.onChangeSubGrupo.bind(this);
        this.onChangeFormaOrg = this.onChangeFormaOrg.bind(this);
        this.onChangeProcedimento = this.onChangeProcedimento.bind(this);
    }

    async componentDidMount() {
        await this.getDates()
    }

    async getDates() {
        this.setState({ loading: true })
        const datesDb = await getUltimaImportacao()
        const dates = datesDb.data

        const dataGrupo = dates.dataGrupo != '' ? moment(dates.dataGrupo).format('MM/YYYY') : ''
        const dataSubGrupo = dates.dataSubGrupo != '' ? moment(dates.dataSubGrupo).format('MM/YYYY') : ''
        const dataFormaOrg = dates.dataFormaOrg != '' ? moment(dates.dataFormaOrg).format('MM/YYYY') : ''
        const dataProcedimento = dates.dataProcedimento != '' ? moment(dates.dataProcedimento).format('MM/YYYY') : ''

        let ultimaImport = {
            dataGrupo,
            grupoDisabled: dataGrupo != '' && moment(dates.dataGrupo).month() == moment().month(),
            dataSubGrupo,
            subGrupoDisabled: dataSubGrupo != '' && moment(dates.dataSubGrupo).month() == moment().month(),
            dataFormaOrg,
            formaOrgDisabled: dataFormaOrg != '' && moment(dates.dataFormaOrg).month() == moment().month(),
            dataProcedimento,
            procedimentoDisabled: dataProcedimento != '' && moment(dates.dataProcedimento).month() == moment().month(),
        }

        console.log(ultimaImport)

        this.setState({ loading: false, ultimaImport: ultimaImport, loading2: false })
    }

    async onChangeGrupo(e) {
        this.setState({ loading2: true, error: "" })
        const file = e[0];
        try {
            await postGrupo(file)
            await this.getDates()
        } catch (error) {
            this.setState({ loading2: false })
            let msg = "Erro ao importar o arquivo. Entre em contato conosco"
            if (error.response && error.response.data && error.response.data.error) {
                msg = error.response.data.error
            }
            this.setState({ error: msg })
        }
    }

    async onChangeSubGrupo(e) {
        this.setState({ loading2: true, error: "" })
        const file = e[0];
        try {
            await postSubGrupo(file)
            await this.getDates()
        } catch (error) {
            this.setState({ loading2: false })
            let msg = "Erro ao importar o arquivo. Entre em contato conosco"
            if (error.response && error.response.data && error.response.data.error) {
                msg = error.response.data.error
            }
            this.setState({ error: msg })
        }
    }

    async onChangeFormaOrg(e) {
        this.setState({ loading2: true, error: "" })
        const file = e[0];
        try {
            await postFormaOrg(file)
            await this.getDates()
        } catch (error) {
            this.setState({ loading2: false })
            let msg = "Erro ao importar o arquivo. Entre em contato conosco"
            if (error.response && error.response.data && error.response.data.error) {
                msg = error.response.data.error
            }
            this.setState({ error: msg })
        }
    }

    async onChangeProcedimento(e) {
        this.setState({ loading2: true, error: "" })
        const file = e[0];
        try {
            await postProcedimento(file)
            await this.getDates()
        } catch (error) {
            this.setState({ loading2: false })
            let msg = "Erro ao importar o arquivo. Entre em contato conosco"
            if (error.response && error.response.data && error.response.data.error) {
                msg = error.response.data.error
            }
            this.setState({ error: msg })
        }
    }

    getText(val, disabled) {
        return disabled ? `Última vigência ${val}. A importação está desabilitada pois esta tabela está atualizada!` : `Última vigência ${val}.`
    }

    render() {
        return (
            <React.Fragment>
                {this.state.loading2 && <LoadingFullScreen></LoadingFullScreen>}

                {this.state.loading ? (<div className="text-center"><PreLoaderWidget /></div>) :
                    <div className="container-fluid">
                        <h3>Importação de Tabelas SIGTAP</h3>
                        <hr />
                        <h5>Após baixar as tabelas do site http://sigtap.datasus.gov.br/tabela-unificada/app/download.jsp, faça a descompactação do arquivo ZIP</h5>

                        {this.state.error != "" ? (
                            <Notificacao
                                msg={this.state.error}
                                nameclass={this.state.nameclass}
                            />
                        ) : null}

                        <Row>
                            <Col>
                                <label>Procure o arquivo tb_grupo.txt</label>
                                <InputFileIcon
                                    icon={IconFile}
                                    placeholder="tb_grupo.txt"
                                    type="file"
                                    accept=".txt"
                                    onChange={this.onChangeGrupo}
                                    width='100%'
                                    disabled={this.state.ultimaImport.grupoDisabled}
                                />
                                {this.state.ultimaImport.dataGrupo != '' ?
                                    <p className='mt-1' style={{ color: this.state.ultimaImport.grupoDisabled ? 'green' : 'red' }}>
                                        {this.getText(this.state.ultimaImport.dataGrupo, this.state.ultimaImport.grupoDisabled)}
                                    </p> :
                                    null
                                }
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col>
                                <label>Procure o arquivo tb_sub_grupo.txt</label>
                                <InputFileIcon
                                    icon={IconFile}
                                    placeholder="tb_sub_grupo.txt"
                                    type="file"
                                   accept=".txt"
                                    onChange={this.onChangeSubGrupo}
                                    width='100%'
                                    disabled={this.state.ultimaImport.subGrupoDisabled}
                                />
                                {this.state.ultimaImport.dataSubGrupo != '' ?
                                    <p className='mt-1' style={{ color: this.state.ultimaImport.subGrupoDisabled ? 'green' : 'red' }}>
                                        {this.getText(this.state.ultimaImport.dataSubGrupo, this.state.ultimaImport.subGrupoDisabled)}
                                    </p> :
                                    null
                                }
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col>
                                <label>Procure o arquivo tb_forma_organizacao.txt</label>
                                <InputFileIcon
                                    icon={IconFile}
                                    placeholder="tb_forma_organizacao.txt"
                                    type="file"
                                    accept=".txt"
                                    onChange={this.onChangeFormaOrg}
                                    width='100%'
                                    disabled={this.state.ultimaImport.formaOrgDisabled}
                                />
                                {this.state.ultimaImport.dataFormaOrg != '' ?
                                    <p className='mt-1' style={{ color: this.state.ultimaImport.formaOrgDisabled ? 'green' : 'red' }}>
                                        {this.getText(this.state.ultimaImport.dataFormaOrg, this.state.ultimaImport.formaOrgDisabled)}
                                    </p> :
                                    null
                                }
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col>
                                <label>Procure o arquivo tb_procedimento.txt</label>
                                <InputFileIcon
                                    icon={IconFile}
                                    placeholder="tb_procedimento.txt"
                                    type="file"
                                    accept=".txt"
                                    onChange={this.onChangeProcedimento}
                                    width='100%'
                                    disabled={this.state.ultimaImport.procedimentoDisabled}
                                />
                                {this.state.ultimaImport.dataProcedimento != '' ?
                                    <p className='mt-1' style={{ color: this.state.ultimaImport.procedimentoDisabled ? 'green' : 'red' }}>
                                        {this.getText(this.state.ultimaImport.dataProcedimento, this.state.ultimaImport.procedimentoDisabled)}
                                    </p> :
                                    null
                                }
                            </Col>
                        </Row>
                    </div>
                }
            </React.Fragment>
        );
    }
}
